import { baseURL } from "constants";

export const INVOICE_PDF_VIEWER_PARAMS =
  "#toolbar=1&statusbar=0&view=FitH&zoom=FitW";

export function normalizeInvoiceMediaPath(pdfPath) {
  if (pdfPath == null) return "";
  let path = String(pdfPath).trim();
  if (!path) return "";

  if (/^(https?:|blob:|data:)/i.test(path)) {
    return path;
  }

  path = path.replace(/^(\.\.\/)+/, "");
  path = path.replace(/^\/+/, "");

  if (path.startsWith("media/")) {
    return `/${path}`;
  }

  if (path.startsWith("documents/")) {
    return `/media/${path}`;
  }

  return path ? `/${path}` : "";
}

export function buildInvoicePreviewUrl(pdfPath) {
  if (pdfPath == null) return "";
  const path = String(pdfPath).trim();
  if (!path) return "";

  if (/^(https?:|blob:|data:)/i.test(path)) {
    return path;
  }

  const mediaPath = normalizeInvoiceMediaPath(path);
  if (!mediaPath) return "";

  if (/^(https?:|blob:|data:)/i.test(mediaPath)) {
    return mediaPath;
  }

  const base = String(baseURL || "").replace(/\/$/, "");
  return base ? `${base}${mediaPath}` : mediaPath;
}

export default buildInvoicePreviewUrl;
